module.exports = __webpack_public_path__ + "img/Qs.9baa39b3.png";